<template>
  <div class="container">
    <Breadcrumb class="breadcrumb">
      <BreadcrumbItem to="/">
        <Icon type="ios-home" class="home" />首页
      </BreadcrumbItem>
      <BreadcrumbItem>学习中心</BreadcrumbItem>
      <BreadcrumbItem>{{ courseName }}</BreadcrumbItem>
      <BreadcrumbItem>串讲练习</BreadcrumbItem>
    </Breadcrumb>

    <div class="practice-header">
      <div class="practice-title">
        <h1>{{ reviewGroupInfo.reviewExerGroupName }}</h1>
      </div>
      <div class="practice-progress">
        <span class="practice-progress-text"
          >共 {{ exerciseList.length }} 道题</span
        >
        <div class="practice-progress-bar">
          <Progress :percent="progressPercent" />
        </div>
      </div>
    </div>

    <div class="practice-container clearfix">
      <div class="fl practice-main">
        <div class="practice-nodata" v-show="exerciseList.length == 0">
          <img src="../../assets/images/nodata-03.png" alt="no-data" />
          <p>老师正在抓紧制作中...... 敬请期待！</p>
        </div>
        <practice-item
          ref="practiceItem"
          v-for="(item, index) in exerciseList"
          :key="index"
          :data="item"
          :index="index"
          practiceType="review"
          :positionId="regId"
          v-model="item.userKey"
          @on-check="changeProgress"
          :scoreMethod="scoringMethod"></practice-item>
      </div>
      <div class="fr practice-bar">
        <Affix :offset-top="160">
          <div class="practice-sheet">
            <h3 class="practice-sheet-header">答题卡</h3>
            <p class="practice-sheet-note">点击图标跳转到对应的题目</p>
            <div class="practice-sheet-score" v-show="doResultVisible">
              <p>
                正确率
                <span class="right-rate">{{ rightPercent }}%</span>
              </p>
              <p>
                <span class="wrong-num">{{ wrongExerciseNum }}</span>
                道错题已加入错题本
              </p>
            </div>
            <div class="practice-sheet-list">
              <happy-scroll
                color="rgba(12, 154, 213 , 1)"
                size="5"
                resize
                hide-horizontal>
                <!-- 排序答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="exerSortType == 2">
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }">
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
                <!-- 题型答题卡 -->
                <ul
                  class="practice-sheet-serial clearfix"
                  v-if="exerSortType == 1">
                  <div v-if="singleFlag == true">单选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }"
                    v-if="singleFlag == true && item.newKeyType == 1">
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="multipleFlag == true">多选题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }"
                    v-if="multipleFlag == true && item.newKeyType == 2">
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>

                  <div v-if="subjectiveFlag == true">主观题</div>
                  <li
                    v-for="(item, index) in exerciseList"
                    :key="index"
                    :class="{
                      right: item.doResult == 1,
                      wrong: item.doResult == -1,
                    }"
                    v-if="subjectiveFlag == true && item.newKeyType == 3">
                    <a v-text="index + 1" @click="scrollPosition(index)"></a>
                  </li>
                </ul>
              </happy-scroll>
            </div>

            <div class="practice-sheet-button" v-show="!doResultVisible">
              <Button type="primary" long @click="savePractice"
                >保存进度</Button
              >
            </div>
            <div class="practice-sheet-button" v-show="!doResultVisible">
              <Button type="warning" long @click="postPractice"
                >我要交卷</Button
              >
            </div>
            <div class="practice-sheet-button" v-show="doResultVisible">
              <Button type="primary" long @click="resetDoResult"
                >重做一遍</Button
              >
            </div>
            <div class="practice-sheet-footer">
              <span>
                <i class="ivu-icon ivu-icon-md-square right"></i> 正确
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square wrong"></i> 错误
              </span>
              <span>
                <i class="ivu-icon ivu-icon-md-square empty"></i> 未做
              </span>
            </div>
          </div>
        </Affix>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from '../../utils/mixin';
import { study } from '../../request';
import PracticeItem from '../../components/exercise/PracticeItem';
import { HappyScroll } from 'vue-happy-scroll';
import 'vue-happy-scroll/docs/happy-scroll.css';
export default {
  mixins: [siteMixin],
  data() {
    return {
      exerciseList: [],
      finishExerciseNum: 0,
      courseName: '',
      scoringMethod: '',
      reviewGroupInfo: {},
      umcrId: 0,
      regId: 0,
      rrId: 0,
      wrongExerciseNum: 0,
      doResultVisible: false,
      exerSortType: 1, //答题排序
      singleFlag: false, //答题卡单选
      multipleFlag: false, //答题卡多选
      subjectiveFlag: false, //答题卡主观
    };
  },
  computed: {
    progressPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let percent = (this.finishExerciseNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
    rightPercent() {
      const totalNum = this.exerciseList.length;
      if (totalNum <= 0) return 0;
      let rightNum = totalNum - this.wrongExerciseNum;
      let percent = (rightNum / totalNum) * 100;
      return Number(percent.toFixed(0));
    },
  },
  mounted() {
    this.setMetaData('串讲练习');
    if (!this.initParams()) return;
    this.getData();
    this.getCourseName();
  },
  methods: {
    initParams() {
      let umcId = this.$route.query.umcid;
      let umcrId = this.$route.query.umcrid;
      let regId = this.$route.query.regid;
      //console.log(catId, umcId);
      if (umcId && umcrId && regId) {
        this.setUmcId(umcId);
        this.umcrId = umcrId;
        this.regId = regId;
        return true;
      } else {
        this.$Message.error('参数错误');
        return false;
      }
    },
    getData() {
      study.getReviewExerciseList(this.umcrId, this.regId).then(res => {
        console.log('reviewpratice', res);
        if (res.status === 1) {
          this.reviewGroupInfo = res.data.reviewExerGroup;
          this.exerSortType = this.reviewGroupInfo.exerSortType;
          this.exerciseList = res.data.reviewPracList;
          if (this.exerciseList.length > 0) {
            this.rrId = this.exerciseList[0].reviewExerGroupRecId;
          }
          const lastPosition = this.reviewGroupInfo.lastPosition;
          this.finishExerciseNum = lastPosition > 0 ? lastPosition : 0;

          //初始化数据
          this.exerciseList.forEach((item, index) => {
            if (item.newKeyType == 1 && !this.singleFlag) {
              this.singleFlag = true;
            }
            if (item.newKeyType == 2 && !this.multipleFlag) {
              this.multipleFlag = true;
            }
            if (item.newKeyType == 3 && !this.subjectiveFlag) {
              this.subjectiveFlag = true;
            }
            if (this.finishExerciseNum > index) {
              if (this.getAnswerIsRight(item)) {
                this.$set(item, 'doResult', 1);
              } else {
                this.$set(item, 'doResult', -1);
              }
            } else {
              item.starCount = 0;
              item.userKey = '';
              item.userKeyImg1 = item.userKeyImg2 = item.userKeyImg3 = '';
              this.$set(item, 'doResult', 0);
            }
          });
        }
      });
    },
    getCourseName() {
      study.getUmcInfo(this.umcId).then(res => {
        if (res.status === 1) {
          this.courseName = res.data.courseName;
          this.setCourseId(res.data.courseId);
          this.scoringMethod = res.data.scoringMethod;
        }
      });
    },
    changeProgress() {
      this.finishExerciseNum++;
    },
    scrollPosition: function (i) {
      var top = document.querySelectorAll('.practice-item')[i].offsetTop - 162;
      window.scroll({ top: top, left: 0, behavior: 'smooth' });
    },
    getAnswerIsRight(item) {
      if (this.keyType(item) === 1) {
        if (item.userKey.trim() == item.rightKey.trim()) return true;
        else return false;
      } else {
        if (item.starCount > 3) return true;
        else return false;
      }
    },
    keyType(item) {
      if (
        item.keyType == '单选' ||
        item.keyType == '判断' ||
        item.keyType == '多选' ||
        item.newKeyType == '1' ||
        item.newKeyType == '2'
      ) {
        return 1; //客观题
      } else {
        return 2; //主观题
      }
    },
    savePractice() {
      this.$Spin.show();
      let lastPosition = 0;
      let ueIdSet = '';
      let userKeySet = '';
      let starSet = '';
      let imageSet = '';
      this.exerciseList.forEach((item, index) => {
        if (item.userKey != '' || item.userKeyImg1) {
          if (ueIdSet) ueIdSet += '|';
          if (userKeySet) userKeySet += '|';
          if (starSet) starSet += '|';
          if (imageSet) imageSet += '|';
          ueIdSet += item.ueId;
          //userKeySet += item.userKey;
          starSet += item.starCount;
          lastPosition = index + 1;
          //答案处理
          if (item.userKey != '') {
            userKeySet += item.userKey;
          } else {
            userKeySet += '-';
          }

          //主观题答案图片
          if (item.userKeyImg1) {
            imageSet += item.userKeyImg1;
            if (item.userKeyImg2) {
              imageSet += `,${item.userKeyImg2}`;
            }
            if (item.userKeyImg3) {
              imageSet += `,${item.userKeyImg3}`;
            }
          } else {
            imageSet += '-';
          }
        }
      });
      if (userKeySet == '') {
        this.$Message.info('还没有做题，无法保存');
        return;
      }
      userKeySet = userKeySet.replace(/-/g, '');
      imageSet = imageSet.replace(/-/g, '');
      let data = {
        rrid: this.rrId,
        lastposition: lastPosition,
        ueidset: ueIdSet,
        userkeyset: userKeySet,
        starcounts: starSet,
        userKeyImgset: imageSet,
      };
      study.saveReviewPractice(data).then(res => {
        //console.log(res);
        if (res.status === 1) {
          this.$Message.success('进度保存成功');
          setTimeout(() => {
            this.$router.push({
              name: 'CourseStudy',
              params: { cid: this.courseId },
            });
          }, 1500);
        } else {
          this.$Message.error('进度保存失败');
        }
        this.$Spin.hide();
      });
    },
    postPractice() {
      this.$Spin.show();
      //检查答案
      this.$refs.practiceItem.forEach(item => {
        item.checkAnswer();
      });
      let ueIdSet = '';
      let userKeySet = '';
      let starSet = '';
      let resultSet = '';
      let imageSet = '';
      this.exerciseList.forEach((item, index) => {
        if (ueIdSet) ueIdSet += '|';
        if (userKeySet || index == 1) userKeySet += '|';
        if (starSet) starSet += '|';
        if (resultSet) resultSet += '|';
        if (imageSet || index == 1) imageSet += '|';
        ueIdSet += item.ueId;
        userKeySet += item.userKey;
        starSet += item.starCount || item.aiScore || 0;
        if (item.doResult == 1) {
          resultSet += '1';
        } else {
          if (item.userKey) this.wrongExerciseNum++;
          resultSet += '0';
        }

        //主观题答案图片
        if (item.userKeyImg1) {
          imageSet += item.userKeyImg1;
          if (item.userKeyImg2) {
            imageSet += `,${item.userKeyImg2}`;
          }
          if (item.userKeyImg3) {
            imageSet += `,${item.userKeyImg3}`;
          }
        }
      });
      let data = {
        umcid: this.umcId,
        rrid: this.rrId,
        ueidset: ueIdSet,
        userkeyset: userKeySet,
        starcounts: starSet,
        resultset: resultSet,
        courseId: this.courseId,
        userKeyImgset: imageSet,
      };
      study.postReviewPractice(data).then(res => {
        //console.log(res);
        if (res.status === 1) {
          this.doResultVisible = true;
        } else {
          this.$Message.error('提交失败');
        }
        this.$Spin.hide();
      });
    },
    resetDoResult() {
      this.reloadPage();
    },
  },
  components: {
    PracticeItem,
    HappyScroll,
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/css/var';
@import '../../assets/css/exercise';
.breadcrumb {
  padding: 1rem 0;
  .home {
    vertical-align: -0.05em;
    margin-right: 0.2rem;
  }
}
.practice-nodata {
  padding: 35px;
  img {
    margin: 0 auto;
  }
  p {
    margin-top: 16px;
    text-align: center;
    font-size: 1.8rem;
  }
}
</style>
